import createApiService, { TServiceReturns } from "@lib/create-api-service";
import { API_ROUTES } from "@utils/constants";
import { reportError } from "@utils/errorReporting";

import { PaymentSource } from "../constants";
import validatePaymentResponse from "../models/payment";
import type { TPaymentData } from "../types";
import getPaymentRequestData from "../utils/getPaymentRequestData";
import mapPaymentResponse from "../utils/mapPaymentResponse";

const paymentService = createApiService({
  url: API_ROUTES.SHIPMENTS_PAY,
  method: "POST",
});

const submitPayment = async (
  shipmentId: string,
  paymentMethod: string,
  source: PaymentSource
): Promise<TServiceReturns<TPaymentData, unknown>> => {
  try {
    const data = getPaymentRequestData(shipmentId, paymentMethod, source);
    const response = await paymentService({ data });

    if (!response.isSuccess) {
      return response;
    }

    const paymentResponse = validatePaymentResponse(response.data);
    const paymentData = mapPaymentResponse(paymentResponse);

    return { isSuccess: true, data: paymentData };
  } catch (error) {
    reportError(error, { module: "order" });
    return { isSuccess: false };
  }
};
export default submitPayment;
